<div class="ficha">
  <a class="volver" [routerLink]="['/buscador']" [queryParams]="queryRetorno">
    ‹ Volver
  </a>

  @if (propiedad(); as prop) {
    <!-- Encabezado: "Departamento, Belgrano" + acciones -->
    <header class="encabezado">
      <h1 class="titulo">
        <strong>{{ titulo() }}</strong
        ><span class="titulo__sep">,</span>
        <span class="titulo__localidad">{{ prop.localidad }}</span>
        @if (prop.emprendimiento) {
          <span class="chip-emprendimiento">Emprendimiento</span>
        }
      </h1>

      <div class="acciones">
        @if (prop.youtube) {
          <button type="button" class="accion" (click)="verVideo()">
            Video
            <svg app-icono nombre="play"></svg>
          </button>
        }
        <button type="button" class="accion" (click)="descargar()">
          Descargar
          <svg app-icono nombre="download"></svg>
        </button>
        <button type="button" class="accion" (click)="compartir()">
          {{ compartido() ? '¡Link copiado!' : 'Compartir' }}
          <svg app-icono nombre="share"></svg>
        </button>
      </div>
    </header>

    <!-- Galería: foto de 384 px + grilla 2×2 de 180 px.
         Se oculta entera cuando la propiedad no tiene ninguna foto: el
         placeholder grande más las cuatro celdas vacías no aportaban nada.
         Desde que se puede publicar sin fotos, es un caso real. -->
    @if (tieneFotos()) {
    <section class="galeria" aria-label="Galería de fotos">
      <!-- app-swipe-horizontal: la foto grande se pasa con el dedo (#15),
           además de los puntos de abajo. Con una sola foto queda apagada. -->
      <div
        class="galeria__principal"
        app-swipe-horizontal
        [swipeDeshabilitado]="galeria().length < 2"
        (swipe)="moverFoto($event)"
      >
        <!-- eager: es la candidata a LCP de la pantalla -->
        <app-foto-propiedad
          [fuentes]="fuentesPrincipal()"
          [alt]="direccionCompleta()"
          loading="eager"
        />
        @if (fuentesPrincipal()) {
          <button
            type="button"
            class="galeria__ampliar"
            (click)="ampliarFoto()"
            aria-label="Ampliar foto"
          >
            <svg app-icono nombre="expand"></svg>
          </button>
        }
      </div>
      <!-- Mobile: puntos del carrusel (Figma 157-762) -->
      @if (galeria().length > 1) {
        <div class="galeria__dots" role="tablist" aria-label="Fotos">
          @for (foto of galeria(); track foto.url; let i = $index) {
            <button
              type="button"
              class="galeria__dot"
              [class.galeria__dot--activo]="i === fotoActiva()"
              (click)="verFoto(i)"
              [attr.aria-label]="'Foto ' + (i + 1)"
            ></button>
          }
        </div>
      }

      <!-- Grilla 2×2 siempre completa: con menos de cinco fotos las celdas
           sobrantes quedan en gris, como el Figma. -->
      @if (galeria().length) {
        <div class="galeria__miniaturas">
          @for (celda of celdasGrilla(); track $index) {
            @if (celda) {
              <button
                type="button"
                class="galeria__miniatura"
                (click)="verFoto(celda.indice)"
                [attr.aria-label]="'Ver foto ' + (celda.indice + 1)"
              >
                <app-foto-propiedad [fuentes]="celda.fuentes" alt="" />
              </button>
            } @else {
              <div class="galeria__miniatura galeria__miniatura--vacia"></div>
            }
          }
        </div>
      }
    </section>
    }

    <!-- Información: descripción + Mt2 | ambientes + WhatsApp
         | pestaña del logo sobre el bloque de precio -->
    <section class="info">
      <!-- Columna 1: descripción, con la superficie alineada a la derecha -->
      <div class="info__columna">
        <div class="info__descripcion">
          <h2 class="info__label">Descripción</h2>
          <p class="info__texto">{{ prop.descripcion || 'Sin descripción.' }}</p>

          <!-- Videos del aviso (spec §7.1: Instagram, TikTok, YouTube) -->
          @if (prop.instagram || prop.tiktok || prop.youtube) {
            <div class="redes">
              @if (prop.instagram) {
                <a class="red" [href]="prop.instagram" target="_blank" rel="noopener" aria-label="Video en Instagram">
                  <svg app-icono nombre="instagram"></svg>
                </a>
              }
              @if (prop.tiktok) {
                <a class="red" [href]="prop.tiktok" target="_blank" rel="noopener" aria-label="Video en TikTok">
                  <svg app-icono nombre="tiktok"></svg>
                </a>
              }
              @if (prop.youtube) {
                <a
                  class="red"
                  [href]="prop.youtube"
                  rel="noopener"
                  aria-label="Video en YouTube"
                  (click)="$event.preventDefault(); verVideo()"
                >
                  <svg app-icono nombre="youtube"></svg>
                </a>
              }
            </div>
          }
        </div>

        @if (prop.superficie != null) {
          <div class="dato">
            <h2 class="info__label">Mt2</h2>
            <p class="dato__valor">{{ prop.superficie }}</p>
          </div>
        }
      </div>

      <!-- Columna 2: ambientes/dormitorios y el botón de WhatsApp -->
      <div class="info__columna">
        <div class="info__datos">
          @if (prop.ambientes != null) {
            <div class="dato">
              <h2 class="info__label">Ambientes</h2>
              <p class="dato__valor">{{ prop.ambientes }}</p>
            </div>
          }
          @if (prop.dormitorios != null) {
            <div class="dato">
              <h2 class="info__label">Dormitorios</h2>
              <p class="dato__valor">{{ prop.dormitorios }}</p>
            </div>
          }
        </div>

        <!-- Sin el botón en los links compartidos de una alianza (#17) -->
        @if (!ocultarContacto) {
          <a
            class="wsp"
            [href]="linkWhatsApp()"
            target="_blank"
            rel="noopener"
            aria-label="Consultar por WhatsApp"
          >
            <svg app-icono nombre="whatsapp"></svg>
          </a>
        }
      </div>

      <!-- Columna 3: pestaña del logo montada sobre el bloque de precio. En
           los links compartidos de una alianza (#17) no va: ni logo ni nombre
           de la inmobiliaria, y el precio queda solo, como en un aviso sin
           logo cargado. -->
      <div class="info__contacto">
        @if (!ocultarContacto) {
          @if (logoInmobiliaria(); as logo) {
            <div class="pestania-logo">
              <img
                class="logo-inmobiliaria"
                [src]="logo"
                [alt]="nombreInmobiliaria() ?? 'Inmobiliaria'"
              />
            </div>
          } @else if (nombreInmobiliaria(); as nombre) {
            <div class="pestania-logo">
              <p class="nombre-inmobiliaria">{{ nombre }}</p>
            </div>
          }
        }

        <div
          class="precios"
          [class.precios--medio]="tamanioPrecio() === 'medio'"
          [class.precios--compacto]="tamanioPrecio() === 'compacto'"
        >
          <!-- La moneda va en Regular y el importe en SemiBold (Figma 22:1094) -->
          @if (precioVentaPartes(); as venta) {
            <span class="precio"
              ><span class="precio__moneda">{{ venta.simbolo }}</span>
              {{ venta.monto }}</span
            >
          }
          @if (precioAlquilerPartes(); as alquiler) {
            <span class="precio"
              ><span class="precio__moneda">{{ alquiler.simbolo }}</span>
              {{ alquiler.monto }} /mes</span
            >
          }
          @if (!precioVenta() && !precioAlquiler()) {
            <span class="precio">Consultar</span>
          }
        </div>
      </div>
    </section>

    <!-- Zona: dirección en texto + mapa geocodificado (spec §7.1). Sin
         coordenadas no se muestra nada en lugar del mapa (definición del
         13/08/2026): la dirección de arriba ya da la zona, y un placeholder
         solo señalaría contenido faltante en una página comercial. -->
    <section class="zona">
      <h2 class="info__label">Zona</h2>
      <p class="zona__direccion">{{ direccionCompleta() }}</p>
      @if (prop.latitud != null && prop.longitud != null) {
        <app-zona-mapa [latitud]="prop.latitud!" [longitud]="prop.longitud!" />
      }
    </section>
    <!-- Hoja A4 de la ficha descargable (FP-25): oculta en pantalla, es lo
         único que sale al imprimir/Descargar. -->
    <app-ficha-pdf
      [propiedad]="prop"
      [galeria]="galeria()"
      [precioVenta]="precioVenta()"
      [precioAlquiler]="precioAlquiler()"
      [direccion]="direccionCompleta()"
      [logo]="logoInmobiliaria()"
      [inmobiliaria]="nombreInmobiliaria()"
      [ocultarContacto]="ocultarContacto"
    />

    <!-- Carrusel de la galería a pantalla completa (botón de ampliar). Mismo
         lightbox que el video, con la variante `full` (1920 px). Se recorre
         con las flechas, con ← → del teclado o con el dedo (#15). -->
    @if (fuentesAmpliada(); as fuentes) {
      <div
        class="lightbox"
        (click)="cerrarFotoAmpliada()"
        role="dialog"
        aria-label="Fotos de la propiedad"
      >
        <div
          class="lightbox__player lightbox__player--foto"
          (click)="$event.stopPropagation()"
          app-swipe-horizontal
          [swipeDeshabilitado]="galeria().length < 2"
          (swipe)="moverVisor($event)"
        >
          <button
            type="button"
            class="lightbox__cerrar"
            (click)="cerrarFotoAmpliada()"
            aria-label="Cerrar foto"
          >
            ✕
          </button>
          <app-foto-propiedad
            [fuentes]="fuentes"
            [alt]="direccionCompleta()"
            ajuste="contain"
          />

          @if (galeria().length > 1) {
            <button
              type="button"
              class="lightbox__flecha lightbox__flecha--izq"
              (click)="fotoAnterior()"
              aria-label="Foto anterior"
            >
              <svg app-icono nombre="caret-left"></svg>
            </button>
            <button
              type="button"
              class="lightbox__flecha lightbox__flecha--der"
              (click)="fotoSiguiente()"
              aria-label="Foto siguiente"
            >
              <svg app-icono nombre="caret-right"></svg>
            </button>
            <p class="lightbox__contador" aria-live="polite">
              {{ (visorIndice() ?? 0) + 1 }} / {{ galeria().length }}
            </p>
          }
        </div>
      </div>
    }

    <!-- Lightbox del video de YouTube (Figma node 22-1215) -->
    @if (videoAbierto() && videoEmbedUrl(); as embed) {
      <div
        class="lightbox"
        (click)="cerrarVideo()"
        role="dialog"
        aria-label="Video de la propiedad"
      >
        <div class="lightbox__player" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="lightbox__cerrar"
            (click)="cerrarVideo()"
            aria-label="Cerrar video"
          >
            ✕
          </button>
          <iframe
            [src]="embed"
            title="Video de la propiedad"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    }
  } @else if (cargando()) {
    <p class="ficha__vacia">Cargando propiedad…</p>
  } @else {
    <p class="ficha__vacia">
      No pudimos cargar esta propiedad. Volvé al buscador e intentá de nuevo.
    </p>
  }
</div>
